import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TileLayoutComponent } from '@progress/kendo-angular-layout';
import { BaseComponent } from '../../models/base-component.model';
import { CollectionDashboardService } from '../../services/collection-dashboard.service';
import { last, takeUntil } from 'rxjs';
import { Response } from '../../interfaces/response.interface';
import { CartService } from '../../../shared/services/cart.service';
import { INotificationService } from '../../../shared/services/inotification.service';
import { RedeploymentOrderService } from '../../../modules/redeployment-orders/services/redeployment-order.service';
import { BooleanResult } from '../../interfaces/boolean-result.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { SVGIcon, thumbUpIcon, xIcon } from '@progress/kendo-svg-icons';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})

export class HomeComponent extends BaseComponent implements OnInit {

  @ViewChild("tileContainer", { static: true }) public tileContainer: TileLayoutComponent;

  public entity: Response;


  openTimeout: boolean = false;

  dialogNo: SVGIcon = xIcon;
  dialogYes: SVGIcon = thumbUpIcon;
  dialogLoader: boolean = false;
  dialogIcon: boolean = true;

  timedOutCartItems: any;
  timedOutCartMiscItems: any;

  constructor(private router: Router,
              private collectionDashboardService: CollectionDashboardService,
              private notificationService: INotificationService,
              private orderService: RedeploymentOrderService,
              private cartService: CartService) { super(); }

  ngOnInit(): void {
    try {
      this.collectionDashboardService.getCollection()
        .pipe(takeUntil(this.subscription))
        .subscribe({
          next: (data) =>
          {
            this.entity = data;

            this.cartService.getTimedOutCartItems().subscribe((data: any[]) => {
              this.timedOutCartItems = data;

              this.cartService.getTimedOutCartMiscItems().subscribe((data: any[]) => {
                this.timedOutCartMiscItems = data;

                if (this.timedOutCartItems.length > 0 || this.timedOutCartMiscItems.length > 0) {
                  this.openTimeoutDialog();
                }
              });
            });
          }
        });
    } catch (err) {
      console.log(err);
    }
  }

  navigateTo(endpoint: string) {
    this.router.navigate([endpoint]);
  }

  redirectToCollection(collectionId: number, collection_Name: string) {
    //redirect to the item search page
    //filter out the collection ID
    this.router.navigate(['/Item'], {
      queryParams: { collectionId: collectionId, collection_Name: collection_Name }
    });
  }

  openTimeoutDialog() {
    this.openTimeout = true;
  }

  closeTimeoutDialog() {
    this.openTimeout = false;
  }

  acknowledgeTimedOutItems() {
    this.orderService.acknowledgeTimeoutItems().subscribe({
      next: (res: BooleanResult) => {
        if (res.wasSuccessful) {
          //redirect Home Page
          var baseUrl = window.location.href.replace(this.router.url, '/');
          window.location.replace(baseUrl);

        } else {
          var errors = res.errors;
          this.notificationService.show({ type: 'error', title: "Error!", description: res.message });
        }
      },
      error: (e: HttpErrorResponse) => {
        var errorMsg: string = e.error;
        if (typeof e.error === "object") {
          errorMsg = e.error.title
        }
        this.notificationService.show({ title: "Error!", type: "error", description: errorMsg ?? "Something Went Wrong!" });
      }
    });
  }

}
